import { render, staticRenderFns } from "./PublicationsList.vue?vue&type=template&id=2ef2a53d"
import script from "./PublicationsList.vue?vue&type=script&lang=ts"
export * from "./PublicationsList.vue?vue&type=script&lang=ts"
import style0 from "./PublicationsList.vue?vue&type=style&index=0&id=2ef2a53d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports